import { canBeDownloaded } from '../../checkout-v2/utils/list-utils';
import type { CartItem, SummaryItemDto } from '../reducers/checkout.reducer';
import { isCheckoutAllowed, isPrintfileAvailable } from '../utils/checkout-utils';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { getProductQuantity, isVariableProduct } from '@app/product/utils/product-utils';
import { I18nService } from '@app/shared/utils/i18n.service';

/** @see isVariableProduct */
@Pipe({ name: 'isVariableProduct', standalone: true })
export class IsVariableProductPipe implements PipeTransform {
	/** @see isVariableProduct */
	transform(item: CartItem): boolean {
		return isVariableProduct(item.product);
	}
}

/** @see isPrintfileAvailable */
@Pipe({ name: 'isPrintfileAvailable', standalone: true })
export class IsPrintfileAvailablePipe implements PipeTransform {
	/** @see isPrintfileAvailable */
	transform(item: CartItem): boolean {
		return isPrintfileAvailable(item);
	}
}

/** Check if a product is downloadable by inspecting its metadata.order_integration field */
@Pipe({ name: 'canBeDownloaded', standalone: true })
export class CanBeDownloadedPipe implements PipeTransform {
	/** Check if a product is downloadable by inspecting its metadata.order_integration field */
	transform(item: CartItem | api.OrderProductDto | SummaryItemDto): boolean {
		return canBeDownloaded(item);
	}
}

/** A pipe to see if checkout is allowed. */
@Pipe({ name: 'isCheckoutAllowed', standalone: true })
export class IsCheckoutAllowedPipe implements PipeTransform {
	/** A pipe to see if checkout is allowed. */
	transform(input: CartItem | CartItem[]): boolean {
		return Array.isArray(input) ? input.every(isCheckoutAllowed) : isCheckoutAllowed(input);
	}
}

/** A pipe to get the product quantity. */
@Pipe({ name: 'getProductQuantity', standalone: true })
export class GetProductQuantityPipe implements PipeTransform {
	/** A pipe to get the product quantity. */
	transform(item: CartItem | api.OrderProductDto | SummaryItemDto): number {
		return getProductQuantity(item);
	}
}

/** A pipe to get the quantity unit. */
@Pipe({ name: 'getQuantityUnit', standalone: true })
export class GetQuantityUnitPipe implements PipeTransform {
	private readonly i18n = inject(I18nService);

	/** A pipe to get the quantity unit. */
	transform(item: CartItem | api.OrderProductDto | SummaryItemDto): string {
		const unit = this.i18n.getText(item?.product?.metadata?.unit);
		return unit || $localize`:@@DefaultQuantityUnit:pcs`;
	}
}
